var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":function($event){return _vm.onSelect(_vm.k, _vm.v)}}},[_c('a',{attrs:{"data-value":_vm.k,"data-label":_vm.v}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.v)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }